import { MathJax } from 'better-react-mathjax'
import { useEffect } from 'react'
import './Mathjax.css'

/**
 * Renders mathjax.
 * @param {string} html - v2 mathjax and to some extent v3 mathjax.
 * @param {boolean} useDefaultSystemFont - Set this to false in case the parent component wants to use the application
 * default font set in tailwind.config.js: gilroy font for the textual part in mathjax. By default, it's true and then
 * it will use the system default fonts to render the textual part. Setting this to true doesn't affect the parts of the
 * mathjax whose tags have their own font-family as these tags' font-family overrides our fonts set here.
 * @returns JSX
 */
const Mathjax = ({ html, useDefaultSystemFont = false, ...props }) => {
    const updatedHtml = html?.replace(/\\"/gm, '"')

    useEffect(() => {
        const failsafeRenderTimer = setTimeout(() => {
            window.MathJax?.Hub?.Queue(() => window.MathJax.Hub.Typeset())
        }, 500)
        return () => {
            clearTimeout(failsafeRenderTimer)
        }
    }, [])

    return (
        <MathJax
            // Setting `dynamic` to true because typesetting should be done repeatedly whenever the content changes.
            // This will prevent issues of the content not being typeset. [docs](https://github.com/fast-reflexes/better-react-mathjax#dynamic-boolean--undefined)
            dynamic
            id="testplayer-mathjax"
            dangerouslySetInnerHTML={{
                __html: updatedHtml,
            }}
            {...props}
        />
    )
}

export default Mathjax
